import React from "react";

interface CardProps {
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ children }) => {
  return (
    <div className="bg-white border rounded-xl p-4 shadow-sm">{children}</div>
  );
};

export default Card;
